export const ARCHIVING_UNLOAD = 'ARCHIVING_UNLOAD'

export const unload = (companyKey) => ({
  type: ARCHIVING_UNLOAD,
  companyKey
})
